<div [ngClass]="{
    'bg-[#FFEEDD] p-4 border-b-1 border-[#FFB95A] md:flex text-[#382100]': !hideHeaderDiv,
    'service-title': hideHeaderDiv}">
    <div class="">
        <h2 class="text-xl md:text-3xl lg:headline-07 font-bold md:mx-2">Ambulancia</h2>
    </div>
    <div class="pl-[15px] md:pl-0">
        <div class="mt-4 md:mt-0">

            <div class="md:mx-4">
                <p class="paragraph-default text-[#382100] ">
                    <strong>Expediente:</strong> {{ expediente || '#Procesando...' }}
                </p>
                <p class="paragraph-default text-[#2F1D00]">
                    <strong>Fecha:</strong> {{ fecha || 'Procesando...' }} | {{ hora || '--:--' }}
                </p>
            </div>

            <div class="md:m-4  flex">
                <app-status-chip [status]="'confirmado'"></app-status-chip>
            </div>


        </div>
    </div>
</div>

<div [ngClass]="{
    'bg-[] text-[#2F1D00] p-6 md:p-12 max-w-xl mx-auto': !hideHeaderDiv,
    'bg-white text-[#134F82] p-6 md:p-12 max-w-xl mx-auto': hideHeaderDiv
}">
    <!-- Título -->
    <h2 class="text-lg md:text-xl lg:headline-05 font-bold mb-4 md:mb-2">Tu ambulancia está en camino</h2>
    <p class="paragraph-default mb-6">
        Alguien te contactará en breve para dar seguimiento a tu servicio.
    </p>


    <button
        [ngClass]="{
            'w-full h-12 bg-[#462A00] text-white button-medium rounded-full flex items-center justify-center gap-2 hover:bg-[#685039] transition': !hideHeaderDiv,
            'w-full h-12 bg-[#134f82] text-white button-medium rounded-full flex items-center justify-center gap-2 hover:bg-[#0f3a6b] transition': hideHeaderDiv
        }"
        (click)="contactar()">
        <mat-icon>phone</mat-icon>
        Contactar
    </button>

    <div [ngClass]="{
        'bg-[#fff8f4] border border-[#B87400] rounded-xl p-4 space-y-4 text-[#382100] mt-6': !hideHeaderDiv,
        'bg-[#D2E4FF29] border border-[#D9E7F3] rounded-xl p-4 space-y-4 text-[#134F82] mt-6': hideHeaderDiv
    }">

  <!-- Encabezado -->
  <div [ngClass]="{
      'flex justify-between items-center border-b border-[#B87400] pb-2 cursor-pointer': !hideHeaderDiv,
      'flex justify-between items-center border-b border-[#D9E7F3] pb-2 cursor-pointer': hideHeaderDiv
  }" (click)="toggleMap()" hidden>
    <div class="flex items-center gap-2 font-semibold">
      <mat-icon>location_on</mat-icon>
      <h3 class="headline-03">Dirección</h3>
    </div>
    <mat-icon [ngClass]="{
        'text-[#B87400]': !hideHeaderDiv,
        'text-[#134F82]': hideHeaderDiv
    }">
      {{ mapExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <!-- Contenido desplegable -->
  <div *ngIf="mapExpanded" class="space-y-2">
    <div>
      <p class="paragraph-small">Tu ambulancia está en camino a:</p>
      <p class="paragraph-default">{{ direccionReal || addressInfo?.address || 'Cargando dirección...' }}</p>
    </div>

    <div class="w-full h-64 md:h-auto map-readonly" hidden>
      <app-map 
          width="100%" 
          height="264px"
          [showSearchInput]="false"
          [useNewStructure]="true"
          mode="view"
          [initialLat]="latitud || 19.6078216"
          [initialLng]="longitud || -99.73999">
      </app-map>
    </div>
  </div>

</div>




    <div class="mt-8">
        <h3 class="text-lg md:text-xl lg:headline-05 font-bold mb-1">Detalles del servicio</h3>
        <p class="text-sm md:text-base mb-4">Encuentra todos los datos importantes sobre esta solicitud.</p>

    </div>



    <div [ngClass]="{
        'bg-[#fff8f4] border border-[#B87400] rounded-xl p-4 space-y-4 text-[#382100]': !hideHeaderDiv,
        'bg-[#D2E4FF29] border border-[#D9E7F3] rounded-xl p-4 space-y-4 text-[#134F82]': hideHeaderDiv
    }">

  <!-- Encabezado -->
  <div [ngClass]="{
      'flex justify-between items-center border-b border-[#B87400] pb-2 cursor-pointer': !hideHeaderDiv,
      'flex justify-between items-center border-b border-[#D9E7F3] pb-2 cursor-pointer': hideHeaderDiv
  }" (click)="toggleExpand()">
    <div class="flex items-center gap-2 font-semibold">
      <mat-icon [ngClass]="{
          'text-[#B87400]': !hideHeaderDiv,
          'text-[#134F82]': hideHeaderDiv
      }">add</mat-icon>
      <h3 class="headline-03">Ambulancia</h3>
    </div>
    <mat-icon [ngClass]="{
        'text-[#B87400]': !hideHeaderDiv,
        'text-[#134F82]': hideHeaderDiv
    }">
      {{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <!-- Sección desplegable -->
  <div *ngIf="expanded" class="space-y-4">

    <!-- Fecha y hora -->
    <div [ngClass]="{
        'flex justify-between text-sm border-b border-[#845400] pb-2': !hideHeaderDiv,
        'flex justify-between text-sm border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
      <div class="w-full">
        <p class="headline-02 flex"><strong>Fecha de solicitud</strong></p>
        <p>{{ fecha || 'Procesando...' }}</p>
      </div>
      <div class="w-full">
        <p class="headline-02 flex"><strong>Hora de solicitud</strong></p>
        <p>{{ hora || '--:--' }}</p>
      </div>
    </div>

    <!-- Precio -->
    <div>
      <p class="headline-02 flex"><strong>Precio</strong></p>
      <div class="flex items-center gap-2 text-sm">
        <!-- <p class="text-[#B87400] line-through font-semibold">$1234</p> -->
        <mat-icon fontIcon="workspace_premium" class="text-[#382100] text-base"></mat-icon>
        <span class="headline-02">Cubierto por tu programa</span>
      </div>
    </div>

  </div>
</div>


</div>|